import { CSSProperties, useMemo } from "react";
import { FC } from "react";
import tailwindConfig from "../../tailwind.config.js";

interface Props {
  name: string;
  type: SearchConditionTagType;
  onClick: () => void;
}

export enum SearchConditionTagType {
  Delete,
  Add,
}

const SearchConditionTag: FC<Props> = ({
  name,
  type,
  onClick,
}): JSX.Element => {
  const btnStyle = useMemo<CSSProperties>(() => {
    return {
      backgroundColor:
        type === SearchConditionTagType.Delete
          ? tailwindConfig.theme.colors.red[500]
          : "#000",
    };
  }, [type]);

  return (
    <button
      onClick={onClick}
      className="bg-white px-8 p-4 rounded-full space-x-6 flex items-center text-xs border border-primary"
    >
      <span className="inline-block">{name}</span>
      <div
        className="text-tiny rounded-full text-white w-16 h-16 flex items-center justify-center"
        style={btnStyle}
      >
        {type === SearchConditionTagType.Delete && (
          <i className="Icon icon-Close" />
        )}
        {type === SearchConditionTagType.Add && (
          <i className="Icon icon-Plus" />
        )}
      </div>
    </button>
  );
};
export default SearchConditionTag;
